'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = require('preact');

var _preact2 = require('unistore/preact');

var _preactFela = require('preact-fela');

var _actions = require('../../actions');

var _Core = require('../Core');

var _BellIcon = require('../Icon/BellIcon');

var _BellIcon2 = _interopRequireDefault(_BellIcon);

var _HeaderNotificationContent = require('./HeaderNotificationContent');

var _HeaderNotificationContent2 = _interopRequireDefault(_HeaderNotificationContent);

var _Badge = require('../Core/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var wrapperStyle = function wrapperStyle() {
  return {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  };
};

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);

var extend = {
  dropdownContent: {
    flexWrap: 'wrap',
    padding: '0',
    desktop: {
      width: '304px'
    }
  }
};

var HeaderNotification = function (_Component) {
  _inherits(HeaderNotification, _Component);

  function HeaderNotification() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HeaderNotification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderNotification.__proto__ || Object.getPrototypeOf(HeaderNotification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.toggle = function () {
      _this.setState({ open: !_this.state.open });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HeaderNotification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.unreadNotifications();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inScroll = _props.inScroll,
          mobile = _props.mobile,
          config = _props.config,
          notification = _props.notification,
          notifications = _props.notifications,
          readNotifications = _props.readNotifications,
          unreadNotifications = _props.unreadNotifications;


      return (0, _preact.h)(
        Wrapper,
        null,
        (0, _preact.h)(
          _Core.Dropdown,
          {
            label: (0, _preact.h)(
              'div',
              null,
              (0, _preact.h)(_BellIcon2.default, null),
              notification.unread > 0 && (0, _preact.h)(_Badge2.default, null)
            ),
            mobile: mobile,
            config: config,
            styleExtend: extend,
            dropdownIcon: false,
            toggle: this.toggle,
            open: this.state.open,
            gtm: (0, _utils.getAttrsGtm)('notificacao', { clicktype: 'menu' })
          },
          this.state.open && (0, _preact.h)(_HeaderNotificationContent2.default, {
            inScroll: inScroll,
            mobile: mobile,
            config: config,
            notification: notification,
            notifications: notifications,
            readNotifications: readNotifications,
            unreadNotifications: unreadNotifications
          })
        ),
        inScroll && (0, _preact.h)(_Core.Dividir, null)
      );
    }
  }]);

  return HeaderNotification;
}(_preact.Component);

exports.default = (0, _preact2.connect)('notification', {
  readNotifications: _actions.readNotifications,
  unreadNotifications: _actions.unreadNotifications,
  notifications: _actions.notifications
})(HeaderNotification);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/HeaderNotification.js
// module id = 194
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38